module.exports = __webpack_public_path__ + "media/seher_1.0c.396ffbd0.mp3";